export default __webpack_public_path__ + "static/media/logoHub.e1afec5b.png";